import NiceModal from "@ebay/nice-modal-react";
import { ColumnType } from "src/components";
import { WebsiteSystemItem } from "src/hooks/useWebsiteSystem";
import { formatWebsiteSystemPeriod } from "./formatPeriod";
import { WebsiteSystemEditModal } from "./WebsiteSystemEditModal";
import { WebsiteSystemHistoryDrawer } from "./WebsiteSystemHistoryDrawer";
import { WebsitesShown } from "./WebsiteLogos";
import { WebsiteSystemManageCell } from "./WebsiteSystemManageCell";
import { WebsiteSystemUsageCell } from "./WebsiteSystemUsageCell";

export type GetColumnsProps = {
  canEdit: boolean;
};

export const getColumns = ({ canEdit }: GetColumnsProps): ColumnType<WebsiteSystemItem>[] => [
  {
    title: "ลำดับ",
    key: "order",
    width: 60,
    render: (_value: unknown, _item: WebsiteSystemItem, index: number) => index + 1,
  },
  {
    title: "สถานะระบบ",
    key: "name",
    dataIndex: "name",
    width: 180,
  },
  {
    title: "การใช้งาน",
    key: "usage",
    width: 100,
    render: (_value: unknown, item: WebsiteSystemItem) => <WebsiteSystemUsageCell item={item} canEdit={canEdit} />,
  },
  {
    title: "เว็บที่แสดง",
    key: "websites",
    width: 240,
    render: (_value: unknown, item: WebsiteSystemItem) => <WebsitesShown scope={item.scope} products={item.products} />,
  },
  {
    title: "ช่วงเวลาที่แสดง",
    key: "period",
    width: 200,
    render: (_value: unknown, item: WebsiteSystemItem) =>
      formatWebsiteSystemPeriod({
        typeTime: item.typeTime,
        daysWeek: item.daysWeek,
        startDatetime: item.startDatetime,
        endDatetime: item.endDatetime,
      }),
  },
  {
    title: "จัดการ",
    key: "manage",
    width: 100,
    render: (_value: unknown, item: WebsiteSystemItem) => (
      <WebsiteSystemManageCell
        canEdit={canEdit}
        onEdit={() => NiceModal.show(WebsiteSystemEditModal, { item })}
        onHistory={() => NiceModal.show(WebsiteSystemHistoryDrawer, { item })}
      />
    ),
  },
];
